import {AccountExternal} from "@bounce/shared/consumer/declarations";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";

type Variables = {
  accountId?: string;
  includeOffers?: boolean;
};

type Data = AccountExternal;

export const getAccount = async (variables: Variables): Promise<Data> => {
  if (!variables?.accountId) {
    // @ts-ignore
    return {};
  }

  const result = await axiosConsumerAppInstance.get<Data, AxiosResponse<Data>>(`/user/account`, {
    params: {account_id: variables.accountId, ...(variables.includeOffers ? {include_offers: true} : {})},
  });
  return result.data;
};

export const useGetAccount = (
  variables: Variables,
  options?: BaseQueryOptions<Data, Variables>
): BaseUseQueryResult<Data> => {
  const accountId = variables.accountId;
  const queryKey = accountId
    ? ["account", accountId, ...(variables.includeOffers ? ["with-offers"] : [])]
    : ["invalid-account"];
  return useBaseQuery<Data, Variables>(queryKey, getAccount, variables, options);
};
